module.exports = __webpack_public_path__ + "assets/img/all.9f63e450.png";